import angular from 'angular';
import template from './template.html';
import { EMPLOYER_WORKFLOW_STATUS } from '../../../../employer/constants/employer-workflow';
import './style.scss';

export class CandidateProfileSubmissionLabel {
    submissionLabel = '';

    /* @ngInject */
    constructor($filter) {
        this.$filter = $filter;
    }

    $onChanges() {
        const { employerStatus } = this;

        this.submissionLabel = this.getSubmissionLabel(employerStatus);
    }

    getSubmissionLabel(employerStatus) {
        if (!employerStatus) {
            return null;
        }

        const isCurrentStatusSubmitted = employerStatus.current === EMPLOYER_WORKFLOW_STATUS.REVIEWED;
        const submissionStatusFromHistory = employerStatus.history.find(({ status }) => status === EMPLOYER_WORKFLOW_STATUS.REVIEWED);
        const submissionStatus = isCurrentStatusSubmitted ? employerStatus : submissionStatusFromHistory;

        if (!submissionStatus) {
            return null;
        }

        // eslint-disable-next-line no-undef
        const dateFormatter = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });

        return dateFormatter.format(new Date(submissionStatus.timestamp));
    }
}

export const CandidateProfileSubmissionLabelConfiguration = {
    template,
    bindings: {
        employerStatus: '<',
    },
    controller: CandidateProfileSubmissionLabel,
    controllerAs: 'candidateProfileSubmissionLabelCtrl',
};

angular
    .module('TALENYA-FE')
    .component('candidateProfileSubmissionLabel', CandidateProfileSubmissionLabelConfiguration);